import { render, staticRenderFns } from "./UserAvatarContent.vue?vue&type=template&id=371b69b4&scoped=true"
import script from "./UserAvatarContent.vue?vue&type=script&lang=js"
export * from "./UserAvatarContent.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarContent.vue?vue&type=style&index=0&id=371b69b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b69b4",
  null
  
)

export default component.exports